// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ks-1";
export var quotedThread = "_ks-0";